import { MessageCircle } from 'lucide-react';
import { useLogo } from '../hooks/useLogo';

export default function Header({ onWhatsAppGeral }) {
  const logo = useLogo();
  return (
    <header className="sticky top-0 z-40 bg-mk-bluedark border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-3">
        <a href="#topo" className="flex items-center gap-3 min-w-0" data-testid="header-logo">
          <img src={logo} alt="MK Eletromóveis" className="h-11 w-11 rounded-full shrink-0 object-contain shadow-sm ring-2 ring-white/15" />
          <span className="min-w-0">
            <span className="block font-heading font-extrabold text-white text-base sm:text-lg leading-tight truncate">
              MK Eletromóveis
            </span>
            <span className="block text-[11px] font-medium text-white/60 uppercase tracking-widest">
              Catálogo Digital
            </span>
          </span>
        </a>
        <button
          data-testid="header-whatsapp-store-select"
          onClick={onWhatsAppGeral}
          className="inline-flex items-center gap-2 rounded-full bg-mk-green px-4 py-2 text-sm font-bold text-white shadow-md shadow-mk-green/30 hover:bg-mk-greendark transition-colors duration-300"
        >
          <MessageCircle size={17} strokeWidth={2.5} />
          <span className="hidden sm:inline">Falar no WhatsApp</span>
          <span className="sm:hidden">WhatsApp</span>
        </button>
      </div>
    </header>
  );
}
